import { useNavigate, useSearch } from '@tanstack/react-router';
import { type RouteId, type RoutePathOf, type RouteSearchSelect } from '@/router/route-hooks.types';

const ROUTE_ID = '/_authenticated/_dashboard/accounts/' satisfies RouteId;
const ROUTE_PATH = '/accounts/' satisfies RoutePathOf<typeof ROUTE_ID>;

export const useRouteSearch = <TSelected, TId = typeof ROUTE_ID>(select: RouteSearchSelect<TId, TSelected>) =>
  useSearch({ from: ROUTE_ID, select });

export const useRouteNavigate = () => useNavigate({ from: ROUTE_PATH });
